import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { CreateNetworkModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/customers-service-lib/src/wrapper/inputs/networks/create-network.model';
import { SubmitErrorHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { NetworkCreateFormStep1Controller } from '@app/feature/network/network-create/network-create-form-step-1/network-create-form-step-1.controller';
import { useCreateNetworkContext } from '@app/feature/network/network.context';

export interface NetworkCreateFormControllerProps {
  onError: SubmitErrorHandler<CreateNetworkModel>;
  onSubmit: SubmitHandlerWithDirtyFields<CreateNetworkModel>;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const NetworkCreateFormController = ({
  onError,
  onSubmit,
  onCancel,
  state,
}: NetworkCreateFormControllerProps): React.JSX.Element => {
  const { t } = useTranslation();
  const data = useCreateNetworkContext();

  return (
    <MultiStepFormProvider<CreateNetworkModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          title: t('$.network-create.step-1.title'),
          iconName: 'server-06',
          fields: [
            'name',
            'customerId',
            'description',
            'holder.firstName',
            'holder.lastName',
            'holder.email',
            'holder.address.address',
            'holder.address.city',
            'holder.address.countryCode',
            'holder.address.zipCode',
            'holder.companyName',
            'holder.siret',
            'holder.vatNumber',
            'billingDetails.mandate.documentNumber',
            'billingDetails.mandate.dateOfSignature',
            'billingDetails.bic',
            'billingDetails.iban',
          ],
          component: <NetworkCreateFormStep1Controller />,
        },
      ]}
    />
  );
};
